/* eslint-disable react/prop-types */
import React from 'react';
import { Ban } from 'lucide-react';
import './DprShiftSkippedNotice.css';

const DprShiftSkippedNotice = ({ shift = 'day' }) => {
  const label = shift === 'night' ? 'Night' : 'Day';

  return (
    <div className="dpr-shift-skipped-notice" role="status" aria-live="polite">
      <Ban size={18} aria-hidden />
      <span>
        <strong>{label} shift is skipped.</strong> All log entry actions are disabled for this shift.
        Uncheck <strong>Skip {label} Shift</strong> in the header to edit again.
      </span>
    </div>
  );
};

export default DprShiftSkippedNotice;
